export const ROLE_PERMISSIONS = {
  EMPLOYEE: ["LEAVE_VIEW",
    "LEAVE_APPLY",
    "COMPOFF_VIEW",
    "PROFILE_VIEW",
    "ADVANCE_VIEW",
    "ADVANCE_APPLY",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "ATTENDANCE_VIEW",
    "CLIENT_VIEW"
  ],

  APPROVER: [
    "LEAVE_VIEW",
    "LEAVE_APPLY",
    "LEAVE_APPROVE",
    "LEAVE_VIEW_TEAM",
    "COMPOFF_VIEW",
    "COMPOFF_ADD",
    // "COMPOFF_APPROVE",
    // "ATTENDANCE_VIEW_SELF",
    // "ATTENDANCE_VIEW_TEAM",
    // "ATTENDANCE_APPROVE",
    "PROFILE_VIEW",
    "ADVANCE_APPLY",
    "ADVANCE_VIEW_ALL",
    "ADVANCE_APPROVE",
    "ADVANCE_VIEW",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "CLAIMS_APPROVE",
    "CLAIMS_VIEW_ALL",
    "ATTENDANCE_VIEW",
    "ATTENDANCE_APPROVE",
    "ATTENDANCE_VIEW_ALL",
    "VIEW_HR_DASHBOARD",
    "CLIENT_ADD",
    "CLIENT_VIEW",
    "DSR_VIEW",
    "ONBOARDING_VIEW"

  ],

  HR: [
    "LEAVE_VIEW",
    "LEAVE_APPLY",
    "LEAVE_APPROVE",
    "LEAVE_VIEW_TEAM",
    "COMPOFF_VIEW",
    "COMPOFF_ADD",
    "COMPOFF_APPROVE",
    "HOLIDAY_ADD",
    "PROFILE_VIEW",
    "ALL_PROFILES",
    "ADD_USER",
    "UPDATE_USER",
    "AUDIT_LOG_VIEW",
    "ADVANCE_APPLY",
    "ADVANCE_VIEW_ALL",
    "ADVANCE_APPROVE",
    "ADVANCE_VIEW",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "CLAIMS_APPROVE",
    "CLAIMS_VIEW_ALL",
    "ATTENDANCE_VIEW",
    "ATTENDANCE_APPROVE",
    "ATTENDANCE_VIEW_ALL",
    "VIEW_HR_DASHBOARD",
    "CLIENT_VIEW",
    "ONBOARDING_VIEW",
    "ONBOARDING_APPLY"
  ],
  SUPER_ADMIN: [
    "LEAVE_VIEW",
    "LEAVE_APPLY",
    "LEAVE_APPROVE",
    "LEAVE_VIEW_ALL",
    "COMPOFF_VIEW",
    "COMPOFF_ADD",
    "COMPOFF_APPROVE",
    "HOLIDAY_ADD",
    // "ATTENDANCE_VIEW_SELF",
    // "ATTENDANCE_VIEW_ALL",
    // "ATTENDANCE_APPROVE",
    "PROFILE_VIEW",
    "ALL_PROFILES",
    "ADD_USER",
    "UPDATE_USER",
    "AUDIT_LOG_VIEW",
    "ADVANCE_APPLY",
    "ADVANCE_VIEW_ALL",
    "ADVANCE_APPROVE",
    "ADVANCE_VIEW",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "CLAIMS_APPROVE",
    "CLAIMS_VIEW_ALL",
    "ATTENDANCE_VIEW",
    "ATTENDANCE_APPROVE",
    "ATTENDANCE_VIEW_ALL",
    "VIEW_HR_DASHBOARD",
    "CLIENT_ADD",
    "CLIENT_VIEW",
    "ONBOARDING_VIEW",
    "ONBOARDING_APPLY"


  ],
  ADMIN: [
    "LEAVE_VIEW",
    "LEAVE_APPLY",
    "LEAVE_APPROVE",
    "LEAVE_VIEW_ALL",
    "COMPOFF_VIEW",
    "COMPOFF_ADD",
    "COMPOFF_APPROVE",
    "HOLIDAY_ADD",
    // "ATTENDANCE_VIEW_SELF",
    // "ATTENDANCE_VIEW_ALL",
    // "ATTENDANCE_VIEW_TEAM",
    // "ATTENDANCE_APPROVE",
    "PROFILE_VIEW",
    "ALL_PROFILES",
    "ADD_USER",
    "UPDATE_USER",
    "AUDIT_LOG_VIEW",
    "ADVANCE_APPLY",
    "ADVANCE_VIEW_ALL",
    "ADVANCE_APPROVE",
    "ADVANCE_VIEW",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "CLAIMS_APPROVE",
    "CLAIMS_VIEW_ALL",
    "ATTENDANCE_VIEW",
    "ATTENDANCE_APPROVE",
    "ATTENDANCE_VIEW_ALL",
    "VIEW_HR_DASHBOARD",
    "CLIENT_ADD",
    "CLIENT_VIEW",
    "ONBOARDING_VIEW",
    "ONBOARDING_APPLY"

  ],
  LEAD: [
    "LEAVE_VIEW",
    "LEAVE_APPLY",
    "LEAVE_APPROVE",
    "LEAVE_VIEW_TEAM",
    "COMPOFF_VIEW",
    "COMPOFF_ADD",
    // "ATTENDANCE_VIEW_SELF",
    // "ATTENDANCE_VIEW_TEAM",
    "ATTENDANCE_APPROVE",
    "PROFILE_VIEW",
    "ADVANCE_APPLY",
    // "ADVANCE_VIEW_ALL",
    // "ADVANCE_APPROVE",
    "ADVANCE_VIEW",
    "CLAIMS_VIEW",
    "CLAIMS_APPLY",
    "CLAIMS_APPROVE",
    "CLAIMS_VIEW_ALL",
    "ATTENDANCE_VIEW",
    "ATTENDANCE_VIEW_SELF",
    "ATTENDANCE_VIEW_TEAM",
    "CLIENT_ADD",
    "CLIENT_VIEW",
    "DSR_VIEW",
    "ONBOARDING_VIEW"

  ]
};